<template>
    <div v-if="issue_obj">
        <vs-row>
            <vs-col vs-xs="12" vs-sm="3" vs-lg="3" class="mb-3">
                <vs-input
                    :value="issue_obj.data.id ? `Issue #${issue_obj.data.id}` : 'Auto Generated'"
                    label="Issue ID"
                    readonly
                    class="w-full"
                />
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                <SelectForeign
                    :model="issue_obj.reported_by"
                    label="Reported By"
                    placeholder="Auto Filled"
                    :multiple="false"
                    :load_initial="false"
                    :label_keys="['first_name', 'last_name']"
                    :show_id_in_label="true"
                    :endpoint="`${$store.state.apiendpoints.organisation_users}?is_active=true`"
                    container_class="w-full"
                    input_class=""
                    :use_id_as_value="false"
                    :disabled="true"
                />
                <small class="block text-danger mt-1" v-if="api_errors.resource_allocation">
                    {{ api_errors.resource_allocation.join(', ') }}
                </small>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="5" vs-lg="5" class="mb-3">
                <SelectForeign
                    :model.sync="issue_obj.assigned_reviewers"
                    label="Assgined Incident Managers"
                    placeholder="Type to Search..."
                    :multiple="true"
                    :load_initial="true"
                    :label_keys="['first_name', 'last_name']"
                    :show_id_in_label="false"
                    :endpoint="`${$store.state.apiendpoints.organisation_users}?permission=${manager_dropdown()}&is_active=true`"
                    container_class="w-full"
                    input_class=""
                    :use_id_as_value="false"
                    :close_on_select="false"
                    :disabled="true"
                />
                <small class="block text-danger mt-1" v-if="api_errors.resource_allocation">
                    {{ api_errors.resource_allocation.join(', ') }}
                </small>
            </vs-col>
        </vs-row>
        <vs-row>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="px-0">
                <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mb-3">
                    <label class="vs-input--label block mb-1">Description</label>
                    <vs-textarea v-model="issue_obj.resolution_description" :disabled="!(mode == 'e' && (this.editResolution || this.editExternalResolution))"/>
                    <small class="block text-danger mt-1" v-if="api_errors.resolution_description">
                        {{ api_errors.resolution_description.join(', ') }}
                    </small>
                </vs-col>
                <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mb-3">
                    <label class="vs-input--label block mb-1">Reported Images</label>
                    <FileSelection
                    :images="issue_obj.images"
                    :filter="val => val.image_type == 'p'"
                    :read_only="true"
                    />
                </vs-col>
                <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mb-3">
                    <label class="vs-input--label block mb-1" v-if="mode == 'v'">Resolution Images</label>
                    <FileSelection
                        :images.sync="issue_obj.images"
                        :filter="val => val.image_type === undefined || val.image_type === null || val.image_type == 'w'"
                        :read_only="!(mode == 'e' && (this.editResolution || this.editExternalResolution))"
                    />
                    <small class="block text-danger mt-1" v-if="api_errors.images">
                        {{ api_errors.images.join(', ') }}
                    </small>
                </vs-col>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="8" vs-lg="8" class="px-0">
                <vs-row>
                    <vs-col vs-xs="12" vs-sm="6" vs-lg="6">
                        <label class="vs-input--label block mb-1">Date Created</label>
                        <FormatText :text="issue_obj.created_on" format="datetime" />
                    </vs-col>
                </vs-row>
                <LocationChooser class="mt-3" label="Reported Location" :latitude="issue_obj.data.location_latitude" :longitude="issue_obj.data.location_longitude" :api_errors="{latitude: api_errors.data ? api_errors.data.location_latitude : null, longitude: api_errors.data ? api_errors.data.location_longitude : null}" :disabled="true" />
            </vs-col>
        </vs-row>
            
    </div>
</template>

<script>

import FileSelection from "../Components/FileSelection.vue"
import LocationChooser from '../Components/LocationChooser.vue'

export default {
    props: {
        issue: {
            required: true,
            type: Object
        },
        api_errors: {
            required: true,
            type: Object
        },
        mode: {
            required: true,
            type: String
        },
        manager_dropdown: {
            required: true,
            type: Function
        },
        editResolution: {
            required: true,
            type: Boolean,
            default: false
        },
        editExternalResolution: {
            required: true,
            type: Boolean,
            default: false
        }
    },
    components: {
        FileSelection,
        LocationChooser
    },
    data () {
        return {
            issue_obj: null,
            default_data: {
                category: null,
                chainage_from: null,
                chainage_to: null,
                description: null,
                issue_type: null,
                direction: null,
                authority_type: null,
                location_latitude: null,
                location_longitude: null
            },
            issue_type_options: [],
            authority_type_options: []
        }
    },
    watch: {
        issue: {
            deep: true,
            handler: function (newV) {
                this._set_by_watcher = true
                this.update_issue_obj(newV)
            }
        },
        issue_obj: {
            deep: true,
            handler: function (newV) {
                if (this._set_by_watcher) {
                    this._set_by_watcher = false
                    return
                }
                this.$emit('update:issue', newV)
            }
        }
    },
    mounted() {
        this.update_issue_obj(this.issue)
    },
    methods: {
        update_issue_obj(new_data) {
            if (!new_data) this.issue_obj = null
            else {
                let issue_obj = {...new_data}
                if (!issue_obj.data)
                    issue_obj.data = this.deepclone(this.default_data)
                
                this.issue_obj = issue_obj
            }
        }
    }
}
</script>
